// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact page specific styles */

/* Contact Content */
.contact-content {
  max-width: 1000px;
  margin: 0 auto;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-2xl);
  margin-top: var(--space-2xl);
}

.contact-info h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-lg);
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-md);
  margin-bottom: var(--space-xl);
  padding: var(--space-lg);
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.contact-item .icon-box {
  margin: 0;
  flex-shrink: 0;
}

.contact-details h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-xs);
}

.contact-details p {
  color: var(--gray-600);
  margin: 0;
  font-size: 0.95rem;
}

.contact-form h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-lg);
}

.contact-form-fields {
  background: var(--white);
  padding: var(--space-xl);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.form-group {
  margin-bottom: var(--space-lg);
}

.form-group label {
  display: block;
  font-weight: 500;
  color: var(--gray-700);
  margin-bottom: var(--space-xs);
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: var(--space-sm);
  border: 1px solid var(--gray-300);
  border-radius: var(--radius-md);
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--accent-blue);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

/* Checkbox Group Styling */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  margin-top: var(--space-xs);
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.95rem;
  color: var(--gray-700);
  transition: color 0.3s ease;
}

.checkbox-label:hover {
  color: var(--accent-blue);
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid var(--gray-300);
  border-radius: var(--radius-sm);
  margin-right: var(--space-sm);
  position: relative;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.checkbox-label input[type="checkbox"]:checked + .checkmark {
  background-color: var(--accent-blue);
  border-color: var(--accent-blue);
}

.checkbox-label input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-label input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Form Layout Improvements */
.form-description {
  color: var(--gray-600);
  font-size: 0.95rem;
  margin-bottom: var(--space-md);
  line-height: 1.5;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-md);
}

/* Form Status Messages */
.form-success {
  background: #d1fae5;
  border: 1px solid #10b981;
  color: #065f46;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-lg);
}

.form-error {
  background: #fee2e2;
  border: 1px solid #ef4444;
  color: #991b1b;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-lg);
}

.form-success p,
.form-error p {
  margin: 0;
  font-size: 0.95rem;
}

/* FAQ Section */
.faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.faq-item {
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  transition: all 0.3s ease;
}

.faq-item:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--accent-blue);
}

.faq-item h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.faq-item p {
  color: var(--gray-600);
  line-height: 1.6;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: var(--space-sm);
  }
  
  .contact-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
  
  .faq-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;EAGE,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;EAEE,SAAS;EACT,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;AACF","sourcesContent":["/* Contact page specific styles */\n\n/* Contact Content */\n.contact-content {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.contact-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-2xl);\n  margin-top: var(--space-2xl);\n}\n\n.contact-info h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-lg);\n}\n\n.contact-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-md);\n  margin-bottom: var(--space-xl);\n  padding: var(--space-lg);\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.contact-item .icon-box {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.contact-details h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-xs);\n}\n\n.contact-details p {\n  color: var(--gray-600);\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.contact-form h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-lg);\n}\n\n.contact-form-fields {\n  background: var(--white);\n  padding: var(--space-xl);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.form-group {\n  margin-bottom: var(--space-lg);\n}\n\n.form-group label {\n  display: block;\n  font-weight: 500;\n  color: var(--gray-700);\n  margin-bottom: var(--space-xs);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: var(--space-sm);\n  border: 1px solid var(--gray-300);\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--accent-blue);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n/* Checkbox Group Styling */\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  margin-top: var(--space-xs);\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: var(--gray-700);\n  transition: color 0.3s ease;\n}\n\n.checkbox-label:hover {\n  color: var(--accent-blue);\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkmark {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--gray-300);\n  border-radius: var(--radius-sm);\n  margin-right: var(--space-sm);\n  position: relative;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkmark {\n  background-color: var(--accent-blue);\n  border-color: var(--accent-blue);\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkmark::after {\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.checkbox-label input[type=\"checkbox\"]:focus + .checkmark {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Form Layout Improvements */\n.form-description {\n  color: var(--gray-600);\n  font-size: 0.95rem;\n  margin-bottom: var(--space-md);\n  line-height: 1.5;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-md);\n}\n\n/* Form Status Messages */\n.form-success {\n  background: #d1fae5;\n  border: 1px solid #10b981;\n  color: #065f46;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-lg);\n}\n\n.form-error {\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n  color: #991b1b;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-lg);\n}\n\n.form-success p,\n.form-error p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n/* FAQ Section */\n.faq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.faq-item {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  transition: all 0.3s ease;\n}\n\n.faq-item:hover {\n  box-shadow: var(--shadow-md);\n  border-color: var(--accent-blue);\n}\n\n.faq-item h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.faq-item p {\n  color: var(--gray-600);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: var(--space-sm);\n  }\n  \n  .contact-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n  \n  .faq-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
